<template>
    <div class="rv-create p-0">
        <div class="title p-3 border-bottom border-primary fw-600" v-if="$detect == 'web'">
            Đăng bài viết
        </div>
        <div :class="{
                'body': true,
                'p-3': $detect == 'web'
            }">
            <titleCreate
                :data.sync="form.name"
                :error.sync="error.name"/>
<!--            <newOld :data.sync="form.new_old"/>-->
            <typeStatic :data.sync="form.type" :types="types" :error.sync="error.type"/>
            <div class="mt-4 content">
                <p class="mb-2 fs-14px">Nội dung:</p>
                <editor :content.sync="form.content"/>
                <p class="mb-0 fs-14px text-note-img mt-1">* Nhập nội dung đầy đủ</p>
                <div class="text-danger fs-12px mt-1" v-if="error.content">{{error.content}}</div>
            </div>
            <div style="height: 80px;" v-if="$detect == 'mobile'"></div>
            <div :class="{
                    'confirm mt-4 text-center': true,
                    'p-3 confirm-mobile fixed-bottom bg-white': $detect == 'mobile'
                }">
                <button type="button" class="btn btn-primary"
                        :disabled="loading" @click="submit()">Đăng tin</button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {
        editor: () => import('@/components/editor/index'),
        titleCreate: () => import('@/components/profile/create/title'),
        typeStatic: () => import('@/components/profile/create/typeStatic'),
        // newOld: () => import('@/components/profile/create/newOld'),
    },
    data() {
        return {
            form: {
                name: '',
                content: '',
                type: 1,
            },
            error: {},
            loading: false,
            types : [],
            edit : false
        }
    },
    created() {
        apiGet('/v2/profile/static-params').then(res => {
            this.types = res
        })

        if(this.$route.query.id != null) {
            apiGet('/v2/profile/static/'+this.$route.query.id).then(res => {
                this.form.name = res.data.title ? res.data.title : '';
                this.form.content = res.data.content ? res.data.content : '';
                this.form.type = res.data.type ? res.data.type : '';
                this.edit = true
            }).catch(err => {
                if(err.status == 410) {
                    this.$message({
                        message: err.data.message,
                        type: 'error',
                        center: true,
                    });
                    this.$router.push({
                        name: 'static-pages-create',
                    });
                }
            })
        }

    },
    methods: {
        async submit(){
            if(this.loading) return;
            this.loading = true;
            this.error = {};
            let form = {};
            form.name = this.form.name;
            form.content = this.form.content;
            form.type = this.form.type;
            if(this.edit){
                await apiPut('/v2/profile/static/'+this.$route.query.id, form).then(res => {
                    if(res.success == 1){
                        this.$message({
                            message: res.message,
                            type: 'success',
                            center: true,
                        });
                        this.$router.push({
                            name: 'static_pages',
                        })
                    }else{
                        this.$message({
                            type: 'error',
                            message: res.message,
                            center: true,
                        });
                    }
                }).catch(err => {
                    if(err.status == 422){
                        this.error = err.data.error;
                        this.$message({
                            message: 'Vui lòng kiểm tra lại các trường',
                            type: 'warning',
                            center: true,
                        });
                    }
                });
            }else{
                await apiPost('/v2/profile/static', form).then(res => {
                    if(res.success == 1){
                        this.$message({
                            message: res.message,
                            type: 'success',
                            center: true,
                        });
                        this.$router.push({
                            name: 'static_pages',
                        })
                    }else{
                        this.$message({
                            type: 'error',
                            message: res.message,
                            center: true,
                        });
                    }
                }).catch(err => {
                    if(err.status == 422){
                        this.error = err.data.error;
                        this.$message({
                            message: 'Vui lòng kiểm tra lại các trường',
                            type: 'warning',
                            center: true,
                        });
                    }
                });
            }

            this.loading = false;
        }
    }
}
</script>
<style lang="scss">
input {
    box-shadow: none !important;
    -webkit-appearance: none !important;
}
.rv-create {
    .body {
        .confirm {
            button {
                padding: 8px 60px !important;
            }
        }
        .confirm-mobile {
            box-shadow: 0 -3px 6px rgba(0,0,0,0.16), 0 -2px 4px rgba(0,0,0,0.12);
            button {
                width: 100%;
            }
        }
    }
}
.rv-valiadate-input-form {
    input {
        border: 1px solid #dc3545 !important;
    }
    label {
        color: #dc3545 !important;
    }
}
.rv-create .body .text-position-select {
    top: -13px;
    padding: 0 10px;
    background: #fff;
    margin-left: 10px;
}
.input-focus-effect {
    position: relative;
    display: flex;
    flex-direction: column-reverse;
    input {
        padding: 10px;
        border: 1px solid rgba(0, 0, 0, 0.2);
        display: block;
        width: 100%;
        border-radius: 4px;
        transition: border 0.15s linear;
        background-color: transparent;
        outline: none;
        &:focus {
            border-color: #007bff;
        }
        &:focus + label {
            transform: translateY(0);
            top: -13px;
            color: #007bff;
            background: #fff;
            padding: 0 10px;
            font-size: 14px;
            margin-left: -5px;
        }
    }
    label {
        position: absolute;
        top: 50%;
        left: 1rem;
        transform: translateY(-50%);
        pointer-events: none;
        color: #999;
        transition: 0.15s linear;
        font-size: 16px;
    }
    .input-on-alue {
        transform: translateY(0) !important;
        top: -13px !important;
        color: #007bff !important;
        background: #fff !important;
        padding: 0 10px !important;
        font-size: 14px !important;
        margin-left: -5px !important;
    }
}
</style>
